import {CardIconType, Source} from '@raison/types';
import amex from '~/shared/legacy_res/img/paymentSystems/amex.svg';
import cartes_bancaires from '~/shared/legacy_res/img/paymentSystems/cartes_bancaires.svg';
import dankort from '~/shared/legacy_res/img/paymentSystems/dankort.svg';
import dinersclub from '~/shared/legacy_res/img/paymentSystems/dinersclub.svg';
import discover from '~/shared/legacy_res/img/paymentSystems/discover.svg';
import fedwire from '~/shared/legacy_res/img/paymentSystems/fedwire_logo.svg';
import forbrugsforeningen from '~/shared/legacy_res/img/paymentSystems/forbrugsforeningen.svg';
import jcb from '~/shared/legacy_res/img/paymentSystems/jcb.svg';
import maestro from '~/shared/legacy_res/img/paymentSystems/maestro.svg';
import mastercard from '~/shared/legacy_res/img/paymentSystems/mastercard.svg';
import sepa from '~/shared/legacy_res/img/paymentSystems/sepa.svg';
import swift from '~/shared/legacy_res/img/paymentSystems/swift.svg';
import unionpay from '~/shared/legacy_res/img/paymentSystems/unionpay.svg';
import visa from '~/shared/legacy_res/img/paymentSystems/visa.svg';
import visaelectron from '~/shared/legacy_res/img/paymentSystems/visaelectron.svg';

type key = CardIconType | 'sepa' | 'swift' | 'fedwire';
const icons = {
    visa,
    mastercard,
    amex,
    maestro,
    forbrugsforeningen,
    dankort,
    dinersclub,
    discover,
    unionpay,
    visaelectron,
    jcb,
    sepa,
    swift,
    fedwire,
    cartes_bancaires,
} satisfies Record<key, string> as unknown as Record<key, Source>;

export default icons;
